import { View, Text as PDFText } from '@react-pdf/renderer'

import { ratePolicyLines } from '../../../statement'
import { toLatinDigits } from '../../config/functions'
import styles from './styles/index'

interface RatePolicyProps {
  text: string
}

// Each word is its own Text in a right-to-left wrapping row. This renderer reorders whole
// clauses when one Text mixes Persian with Latin words such as "(Check-in)"; a single
// word has nothing to reorder. Same technique as the hotel address.
const RatePolicy = ({ text }: RatePolicyProps) => {
  const lines = ratePolicyLines(text)
  if (lines.length === 0) return null

  return (
    <View style={styles.main}>
      <View style={styles.titleContainer}>
        <PDFText style={styles.mainTitle}>قواعد نرخ‌نامه</PDFText>
      </View>
      <View style={styles.mainDiv}>
        {lines.map((line, i) => (
          <View key={i} style={styles.line}>
            {toLatinDigits(line)
              .split(/\s+/)
              .map((word, j) => (
                <PDFText key={j} style={styles.word}>
                  {word}
                </PDFText>
              ))}
          </View>
        ))}
      </View>
    </View>
  )
}

export default RatePolicy
